import {Directive, ElementRef} from '@angular/core';
import canAutoPlay from 'can-autoplay';
import videojs from 'video.js';
//import * as HLS from '@videojs/http-streaming';

@Directive({
  selector: '[appVideojs]'
})
export class VideojsDirective {
  player = null;

  constructor(el: ElementRef) {
    //const a = HLS;

    canAutoPlay.video().then((result) => {

      console.log('canAutoPlay', result);

      this.player = videojs(el.nativeElement, {
        controls: true,
        autoplay: true,
        preload: 'none',
        poster: 'https://dl.videos.sportys.com/onlinecourse/images/tvos/p1s1.jpg',
        responsive: true,
        fluid: true
      });


      this.player.src({
        src: 'https://stream.videos.sportys.com/onlinecourse/ltf/discover.m3u8'
      });

    });
  }
}

/*
,

        events: {
          onReady: (event) => {
            console.log('onReady', event);
          },
          onPlay: (event) => {
            console.log('onPlay', event);
          },
          onCaptionsList: (event) => {
            console.log('onCaptionsList', event);
          },
          onCaptionsChanged: (event) => {
            console.log('onCaptionsChanged', event);
          },
          onTime: (event) => {
            console.log('onTime', event, player);

          },
          onError: (event) => {
            console.log('onError', event);
          },
          onPause: (event) => {
            console.log('onPause', event, player);
          },
          onSeek: (event) => {
            console.log('onSeek', event, player);
          },
          onSeeked: (event) => {
            console.log('onSeeked', event, player);
          },
          onIdle: (event) => {
            console.log('onIdle', event, player);
          },
          onAll: (event) => {
            console.log('onAll', event, player);
          }


        }
      });

      player.on('all', (event) => {
        console.log('onAll', event);
        console.log('onAll', player.getState());
        if (event === 'userInactive') {
          playing = playing + 1;
        }
        if (playing > 2 && event === 'userInactive') {
          player.stop();
        }
      });

      player.on('autoplayFailed', (event) => {
        console.log('autoplayFailed', event);
      });
 */
